import { PlayerRepository } from "../../../../data/repository/player/PlayerRepository";
import { Game } from "../../../model/Game";
import { ResponseState, State } from "../../../model/ResponseState";

export interface PlayerGetUnfinishedGamesUseCase {
  invoke: (skip: number, limit: number) => Promise<ResponseState<Array<Game>>>;
}

export class PlayerGetUnfinishedGamesUseCaseImpl implements PlayerGetUnfinishedGamesUseCase {
  private playerRepository: PlayerRepository;

  constructor(playerRepository: PlayerRepository) {
    this.playerRepository = playerRepository;
  }

  async invoke(
    skip: number,
    limit: number,
  ): Promise<ResponseState<Array<Game>>> {
    try {
      let response = await this.playerRepository.getPlayerUnfinishedGames(
        skip,
        limit,
      );
      if (response.isSuccessful) {
        return {
          responseState: State.Success,
          data: response.body!,
        };
      }
      return { responseState: State.Fail, error: response.errorBody! };
    } catch (error) {
      return {
        responseState: State.Error,
        error: { message: String(error), statusCode: 500 },
      };
    }
  }
}
